import { useState, useEffect } from "react";
import { debounce } from "../utils";

export const useCalculateOverlay = () => {
  const headerDiv = document.querySelector("#shopify-section-header header");
  const [overlayTop, setOverlayTop] = useState(headerDiv ? headerDiv.clientHeight : 0);
  const [overlayHeight, setOverLayHeight] = useState(window.innerHeight - (overlayTop ? overlayTop : 0));

  const onResize = debounce(() => {
    setOverlayTop(headerDiv ? headerDiv.clientHeight : 0);
    setOverLayHeight(window.innerHeight - (overlayTop ? overlayTop : 0));
  });

  // debounced resizing re-calcs
  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return {
    overlayTop,
    overlayHeight,
  };
};
